var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { Row, Col } from "react-bootstrap";
import styled from "styled-components";
import { padStart } from "lodash";
import Button from "@irati/ui/src/Button";
import { H6 } from "@irati/ui/src/Typography";
import { FormattedMessage } from "@irati/utils/lang";
import Icon from "@irati/ui/src/Icon";
import Flex from "@irati/ui/src/Flex";
var StyledIcon = styled(Icon)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  width: 53px;\n  height: 32px;\n"], ["\n  display: flex;\n  width: 53px;\n  height: 32px;\n"])));
var StyledRow = styled(Row)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"])));
var UserSavedPaymentCard = /** @class */ (function (_super) {
    __extends(UserSavedPaymentCard, _super);
    function UserSavedPaymentCard() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    UserSavedPaymentCard.prototype.render = function () {
        var _a = this.props, variant = _a.variant, number = _a.number, expiry = _a.expiry, holder = _a.holder, removePaymentMethod = _a.removePaymentMethod;
        return (React.createElement(StyledRow, null,
            React.createElement(Col, { xs: 3 },
                React.createElement(StyledIcon, { icon: "payment", type: variant })),
            React.createElement(Col, { xs: 3 },
                React.createElement(H6, null, holder.name)),
            React.createElement(Col, { xs: 2 },
                React.createElement(H6, { textAlign: "right" },
                    "x-",
                    number)),
            React.createElement(Col, { xs: 2 },
                React.createElement(H6, { textAlign: "right" }, padStart(expiry.month.toString(), 2, "0") + "/" + expiry.year.toString().slice(2))),
            React.createElement(Col, { xs: 2 },
                React.createElement(Flex, { justifyContent: "center" },
                    React.createElement(Button, { destructive: true, onClick: removePaymentMethod },
                        React.createElement(FormattedMessage, { id: "account.savedCard.remove" }))))));
    };
    return UserSavedPaymentCard;
}(Component));
export default UserSavedPaymentCard;
var templateObject_1, templateObject_2;
